import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import styled from "styled-components";
import { Colors } from "../../config";
import FirstCarousal from "./FirstCarousal";
import SecondCarousal from "./SecondCarousal";
import ThirdCarousal from "./ThirdCarousal";
import Button from "../Button";
import { useNavigate } from "react-router";

const BackGround = require("../../assets/images/Background.png");
const CarouselBackGround = require("../../assets/images/img_bg_web.png");
const Airplane = require("../../assets/images/airplane.png");

const Onboarding = ({ onGetStarted }) => {
  const navigate = useNavigate();
  const [indexValue, setIndexValue] = useState(false);
  const renderIndicator = (onClickHandler, isSelected, index, label) => {
    const indicatorStyle = {
      backgroundColor: isSelected ? Colors.brandOne : Colors.brandTwo, // Change the background color based on whether the indicator is selected or not
      width: !indexValue ? 0 : 10,
      height: !indexValue ? 0 : 10,
      display: "inline-block",
      margin: "-10px 8px",
      cursor: "pointer",
      borderRadius: "50%",
    };
    return (
      <li
        style={indicatorStyle}
        onClick={onClickHandler}
        key={index}
        aria-label={`Go to slide ${index + 1}`}
        aria-current={isSelected ? "true" : "false"}
      />
    );
  };

  const arrowStyles = {
    position: "absolute",
    zIndex: 2,
    top: "50%",
    width: "3.333rem",
    height: "3.333rem",
    cursor: "pointer",
    // transform: "translateY(-50%)",
    borderRadius: "25%",
    backgroundColor:Colors.brandOne,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // border:`2px solid ${Colors.brandOne}`
  };
  const arrowNextStyles = {
    ...arrowStyles,
    right: "36%",
  };
  const arrowPrevStyles = {
    ...arrowStyles,
    left: "36%",
  };

  const renderArrowPrev = (onClickHandler, hasPrev, label) =>
    hasPrev && (
      <div style={arrowPrevStyles} onClick={onClickHandler} title={label}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="64"
          height="64"
          fill="none"
          viewBox="0 0 64 64"
        >
          <path
            fill="#fff"
            d="M42.892 5.333H21.111c-9.438 0-15.776 6.07-15.776 15.107v23.12c0 9.037 6.338 15.106 15.776 15.106h21.781c9.435 0 15.776-6.072 15.776-15.109V20.44c0-9.038-6.341-15.107-15.776-15.107z"
            opacity="0.4"
          ></path>
          <path
            fill="#fff"
            d="M29.721 20.588l-10.04 9.995c-.754.752-.754 2.083 0 2.837l10.04 9.995a2 2 0 002.824-2.837l-6.605-6.58h16.947a1.999 1.999 0 100-4H25.94l6.605-6.575c.392-.392.587-.904.587-1.419a2 2 0 00-3.41-1.416z"
          ></path>
        </svg>
      </div>
    );

  const renderArrowNext = (onClickHandler, hasNext, label) => {
    const boolValue = hasNext ? true : false;
    setIndexValue(boolValue);
    return (
      hasNext && (
        <div style={arrowNextStyles} onClick={onClickHandler} title={label}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            fill="none"
            viewBox="0 0 64 64"
          >
            <path
              fill="#fff"
              d="M21.108 58.667h21.781c9.438 0 15.776-6.07 15.776-15.107V20.44c0-9.037-6.338-15.106-15.776-15.106H21.108c-9.435 0-15.776 6.072-15.776 15.109V43.56c0 9.038 6.341 15.107 15.776 15.107z"
              opacity="0.4"
            ></path>
            <path
              fill="#fff"
              d="M34.279 43.412l10.04-9.995c.754-.752.754-2.083 0-2.837l-10.04-9.995a2 2 0 00-2.824 2.837l6.605 6.58H21.113a1.999 1.999 0 100 4H38.06l-6.605 6.575a1.996 1.996 0 00-.587 1.419 2 2 0 003.41 1.416z"
            ></path>
          </svg>
        </div>
      )
    );
  };
  const finishOnboarding = () => {
    localStorage.setItem("appLaunched", "true");
    onGetStarted();
  };
  return (
    <MainContainer>
      <BoxContainer>
        <SkipContainer>
          <Button
            label={"Skip"}
            topBottomPadding="0.5rem"
            leftRightPadding={"1rem"}
            onClick={finishOnboarding}
          />
        </SkipContainer>
        <Carousel
          renderIndicator={renderIndicator}
          renderArrowPrev={renderArrowPrev}
          renderArrowNext={renderArrowNext}
          // centerMode={true}
          // owThumbs={false}
        >
          <FirstCarousal />
          <SecondCarousal />
          <ThirdCarousal />
        </Carousel>
        {!indexValue ? (
          <ButtonContainer>
            <Button
              label={"Get Started"}
              btnColor={Colors.ashBlue}
              topBottomPadding="0.75rem"
              onClick={finishOnboarding}
              width={"12rem"}
              rightIcon={Airplane}
              borderRadius={"2rem"}
            />
          </ButtonContainer>
        ) : null}
      </BoxContainer>
    </MainContainer>
  );
};

export default Onboarding;
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url(${BackGround}) center;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  /* @media only screen and (max-width: 478px) {
    width: 15.625rem;
  } */
  /* overflow: hidden; */
  overflow-x: hidden;
`;
const BoxContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 20px;
  background-color: #fff;
  background: url(${CarouselBackGround}) center;
  align-items: center;
  justify-content:center;
  border-radius: 1.25rem;
  /* @media only screen and (max-width: 478px) {
    width: 100%;
  } */
  width: 40%;
  height: 70%;
  @media only screen and (max-width: 1024px) {
    width: 100%;
    height: 100%;
  }
`;
const SkipContainer = styled.div`
  position: absolute;
  right: 2rem;
  top: 4rem;
  z-index: 9999;
  @media only screen and (max-width: 478px) {
    right: 7rem;
  }
`;
const ButtonContainer = styled.div`
  /* display: flex;
  justify-content: center; */
  margin-top: 37rem;
  position: absolute;
`;
